import React,{useEffect} from "react";
import { Helmet } from 'react-helmet'
import "../styles/index.scss";
import "font-awesome/css/font-awesome.min.css";
const Seo = ({theme}) =>{
    // useEffect(() => {
        
    //     const script = `<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WQGF3RD"
    //     height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`;
        
    //     document.body.prepend(script);
        
    // }, []);
    return(
        <Helmet title="Coding With Karthik"
        script={[{ 
            type: 'text/javascript', 
            innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-WQGF3RD');`
          },
          {
            type: 'text/javascript', 
            src: "https://www.googletagmanager.com/gtag/js?id=G-78F6S83F5K",
            async: true
          },
          { 
            type: 'text/javascript', 
            innerHTML: `window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-78F6S83F5K');`
          }]}
          bodyAttributes={{
            class: theme
        }}
     
        />
    )
}

export default Seo;